"use strict";var e=require("react");exports.usePasswordVisibility=i=>{const[r,s]=e.useState(!1);return[r,()=>i?{label:r?"Hide":"Show",onClick:()=>s(!r)}:void 0]};
